export const PLAN_DAYS = [
  { key: "mon", label: "Mon" }, { key: "tue", label: "Tue" }, { key: "wed", label: "Wed" }, { key: "thu", label: "Thu" },
  { key: "fri", label: "Fri" }, { key: "sat", label: "Sat" }, { key: "sun", label: "Sun" },
];
export const PLAN_MEALS = [
  { key: "breakfast", label: "Breakfast" }, { key: "lunch", label: "Lunch" },
  { key: "dinner", label: "Dinner" }, { key: "snacks", label: "Snacks" },
];

// Local-date helpers (never toISOString: that shifts days in timezones ahead of UTC).
export function ymd(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
export function mondayOf(input) {
  const d = new Date(input);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return ymd(d);
}
export function addDays(iso, n) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return ymd(d);
}
export function shortDate(iso) {
  return new Date(iso + "T00:00:00").toLocaleDateString(undefined, { day: "numeric", month: "short" });
}
export function weekLabel(monday) {
  const thisWeek = mondayOf(new Date());
  if (monday === thisWeek) return "This week";
  if (monday === addDays(thisWeek, 7)) return "Next week";
  return `${shortDate(monday)} – ${shortDate(addDays(monday, 6))}`;
}

// Pre-pick a meal type from the recipes' own tags ("Breakfast", "Snack", "Lunch"...).
export function guessMeal(recipes) {
  const counts = {};
  recipes.forEach((r) => (r.tags || []).forEach((t) => {
    const k = t.toLowerCase().replace(/s$/, "");
    const m = k === "snack" ? "snacks" : ["breakfast", "lunch", "dinner"].includes(k) ? k : null;
    if (m) counts[m] = (counts[m] || 0) + 1;
  }));
  return Object.entries(counts).sort((a, b) => b[1] - a[1])[0]?.[0] || "dinner";
}
